import { render, staticRenderFns } from "./DedicateDomain.vue?vue&type=template&id=6f78bc51&scoped=true&"
import script from "./DedicateDomain.vue?vue&type=script&lang=js&"
export * from "./DedicateDomain.vue?vue&type=script&lang=js&"
import style0 from "./DedicateDomain.vue?vue&type=style&index=0&id=6f78bc51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f78bc51",
  null
  
)

export default component.exports